import React from 'react'
import Popup from "./Popup";
import JsBarcode from 'jsbarcode';

// BarCodePopupButton Component
export default class BarCodePopupButton extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            visible : false
            //,tableRef:React.createRef()
        }
    }    
    componentDidMount(prevProps) {
        JsBarcode(".barcode").init();
    }
    componentDidUpdate(prevProps) {
        JsBarcode(".barcode").init();
     }
    
    // render
    render() {

        return(true) ? (
            <span className="barcode-popup">
                <button 
                    onClick={this.openPopup.bind(this)}
                    hidden={this.props.hidden}
                    >
                        Barcode
                </button>
                <Popup className="barcode-popup" trigger={ this.state.visible }  >
                    <div className="align-right">
                        <button className="close-btn" onClick={() => this.closePopup() }>x</button>
                    </div>
                    <div className='barcode-scroll'  >
                        {this.renderBarcodes()}
                    </div>
                </Popup>
            </span>
        ) :"";
    }
    openPopup(){
        this.setState({
            visible:true
        }); 
        
    }
    closePopup(){
        this.setState({
            visible:false
        });  
    }

    renderBarcodes(){
        let barcodes=[]
        let divArr=[];
        try{
            if(this.props.defaultValue.indexOf("\n")>0){
                let lines=this.props.defaultValue.split("\n");
                lines.forEach(line => {
                    if(line.indexOf(":")>0){
                        let title=line.substring(0,line.indexOf(":")).trim();
                        let code=line.substring(line.indexOf(":")+1).trim();
                        barcodes.push({title,code});
                    }
                });
            } else {
                //JsBarcode("#bc1", this.props.defaultValue, {format: "code128"});
                barcodes.push({ title:this.props.title , code:this.props.defaultValue});
            }
            let keyNo=0;
            barcodes.forEach(barcode=>{
                
                keyNo++;
                divArr.push(React.createElement("span",{"key":`bcSpan${keyNo}`},barcode.title))
                divArr.push(React.createElement("br",{"key":`bcBr${keyNo}`}))
                let bc= React.createElement("svg",{
                    "className":"barcode"
                    ,"jsbarcode-format":"code128"
                    ,"jsbarcode-value":barcode.code
                    ,"jsbarcode-textmargin":"0"
                    ,"jsbarcode-fontoptions":"bold"                
                    ,"key":`bcSvg${keyNo}`  
                })
                divArr.push(bc);
                divArr.push(React.createElement("br",{"key":`bcBr2-${keyNo}`}))
                
            })    
    
        } catch(ex){}
        return divArr;
    }
}

